
export default class PlayingState {

	constructor (scene, fight) {

		this.scene = scene;
		this.fight = fight;
		this.name = "playing";
	}

	selectCard (card, touch) {

		if (this.fight.done)
			return;

		let model = this.fight.find(card.id);
		if (!model.canBePlayed)
		  return;
		if (model.hasTarget)
		  this.selected = model;
		else if (touch && (!this.selected || this.selected !== model))
			this.selected = model;
		else if (this.selected && this.selected.hasTarget)
			delete this.selected;
		else {
		  model.play();
		  delete this.selected;
		  if (!this.fight.done && !this.fight.choosingHand) 
		  	this.scene.save();
		}
	}

	selectSkill (touch) {

		if (this.fight.done)
			return;

		let player = this.fight.player;
		if (!player.canUseSkill)
			return;
		if (touch && (!this.selected || this.selected !== player))
			this.selected = player;
		else if (this.selected && this.selected.hasTarget)
			delete this.selected;
		else {
		  player.useSkill();
		  delete this.selected;
		  if (!this.fight.done && !this.fight.choosingHand) 
		  	this.scene.save();
		}
	}

	selectEntity (entity) {

		if (this.fight.done)
			return;

		if (this.selected && !this.selected.hasTarget) {
			this.unselect();
			return;
		}

		if (this.selected)
		  if (this.selected.canBePlayed && this.selected.canTarget(this.fight.find(entity.id))) {
		    this.selected.play(this.fight.find(entity.id));
		    delete this.selected;
			  if (!this.fight.done && !this.fight.choosingHand)
			  	this.scene.save();
		  }
	}

  endTurn () {

    if (this.fight.done)
      return;

    this.fight.endPlayerTurn();
  }

  cardHalo (card) {

		if (this.fight.done)
			return;

		let model = this.fight.find(card.id);
		if (this.selected && model === this.selected)
			return "selected-halo";
		if (model.canBePlayed && ((model.model.edge && model.isFirstNonFrozenInHand()) || model.retaliateGlowActive))
		  return "synergy-halo active-halo";
		if (model.canBePlayed)
		  return "active-halo";
		return;
  }

  skillHalo () {

		if (this.fight.done)
			return;

		let player = this.fight.player;
		if (this.selected && player === this.selected)
		  return "selected-halo";
		if (player.canUseSkill)
		  return "active-halo";
		return;
  }

  unselect () {

  	delete this.selected;
  }
}
